export const HOME_AIRPORT_POPOVER_TITLE = "Home airport";
export const HOME_AIRPORT_INPUT_LABEL = "Enter home airport";
